import type { ResolvedComponent } from '@inertiajs/react';
import { Button } from '@/components/ui/Button';
import { RevealOnScroll } from '@/components/ui/RevealOnScroll';
import { trackUmamiEvent } from '@/lib/analytics';

const wrap = 'mx-auto max-w-[1120px] px-5 md:px-10';
const ctasClassName = 'flex flex-col gap-3 min-[520px]:flex-row min-[520px]:flex-wrap';

/** 404, matching the mockup's `.nf` block. Rendered inside the default `PublicLayout`
 * (header + footer + sticky mobile CTA), unlike the legacy standalone 404. */
const NotFound: ResolvedComponent = () => (
  <div className={wrap}>
    <RevealOnScroll>
      <div className="flex min-h-[60vh] flex-col justify-center py-[60px]">
        <div className="font-display text-primary text-[15px] tracking-[.2em]">404</div>
        <h1 className="t-h1 [&_em]:text-primary-deep mt-3.5 mb-[18px] [&_em]:italic">
          This page <em>slipped away</em>.
        </h1>
        <p className="text-ink-soft mb-7 max-w-[44ch]">
          The page you're looking for isn't here — let's get you back to something clean.
        </p>
        <div className={ctasClassName}>
          <Button variant="solid" as="link" href="/">
            Back home
          </Button>
          <Button
            variant="ghost"
            as="link"
            href="/contact"
            onClick={() => trackUmamiEvent('cta_request_visit', { location: 'not_found' })}
          >
            Contact us
          </Button>
        </div>
      </div>
    </RevealOnScroll>
  </div>
);

export default NotFound;
